import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { FilterTabWrapper } from './styles'
import i18n from 'i18next'
import dayjs from 'dayjs'
import RegisterMultiSelect from '../RegisterMultiSelect'
import { SearchButton } from '../Button'
import { integerNumberOnly } from './advanceSearchOptions'
import { dropdownCategory, getDropDownOptions } from '../../common/const'
import { dropDownContentListApi } from '../../features/dropdown/dropdownAPI'
import { fieldNames } from './Defines/registrationTabDefine'

function RegistrationTab (props) {
  const { onSearchSubmit, defaultValue } = props
  const { register, handleSubmit, formState: { errors }, setError, getValues, setValue, clearErrors, watch } = useFormContext()
  const [errorFields, setErrorFields] = React.useState([])
  const [DropDownList, setDropDownList] = React.useState({})
  const allowedChars = '0123456789.'
  const address = watch('license.address')
  const classNo = watch('license.classNo')
  const number = watch('license.number')

  React.useEffect(() => {
    setDropDownList({})
    // Get DropDown data
    const dropdownKey = {
      0: dropdownCategory.withLease,
      1: dropdownCategory.usage,
      2: dropdownCategory.privateBusinessUse,
      3: dropdownCategory.voluntaryInsuranceType,
      4: dropdownCategory.expensesIncludingLease,
      5: dropdownCategory.regularMaintenanceCycle
    }
    Object.entries(dropdownKey).map(async (value) => {
      const response = await dropDownContentListApi({ categoryId: value[1] })
      // setDropDownListを更新
      setDropDownList(prevState => ({ ...prevState, [value[1]]: response.data.rows }))
    })
  }, [])

  const onSubmit = data => {
    onSearchSubmit(data)
  }

  const addZeroBeforeDot = (item) => {
    if (getValues(item).length === 1) {
      getValues(item).charAt(0) === '.' && setValue(item, `0${getValues(item)}0`)
    } else {
      getValues(item).charAt(0) === '.' && setValue(item, `0${getValues(item)}`)
    }
  }

  const onNumberBlur = field => () => {
    getValues(`${field}.from`) && addZeroBeforeDot(`${field}.from`)
    getValues(`${field}.to`) && addZeroBeforeDot(`${field}.to`)
    clearErrors([`${field}.from`, `${field}.to`])
    const index = errorFields.indexOf(`${field}.from`)
    if (index > -1) {
      errorFields.splice(index, 1)
    }
    const from = getValues(`${field}.from`)
    const to = getValues(`${field}.to`)
    if (parseFloat(from) > parseFloat(to) && !Number.isNaN(parseFloat(from)) && !Number.isNaN(parseFloat(to))) {
      setError(`${field}.from`, {
        type: 'manual',
        message: i18n.t('VEHICLE_VEHICLE-LIST_POPUP-WARNING2_LABEL')
      })
      setErrorFields(prevState => [...prevState, `${field}.from`])
    }
    if ((from && !/^[0-9.]*$/.test(from)) || (to && !/^[0-9.]*$/.test(to))) {
      setError(`${field}.from`, {
        type: 'manual',
        message: i18n.t('VEHICLE_VEHICLE-LIST_WARNING-NUMERIC_LABEL')
      })
      setErrorFields(prevState => [...prevState, `${field}.from`])
    }
  }

  const onDateBlur = field => () => {
    clearErrors([`${field}.from`, `${field}.to`])
    const from = Date.parse(getValues(`${field}.from`))
    const to = Date.parse(getValues(`${field}.to`))
    if (from > to && !Number.isNaN(from) && !Number.isNaN(to)) {
      setError(`${field}.from`, {
        type: 'manual',
        message: i18n.t('VEHICLE_VEHICLE-LIST_POPUP-WARNING2_LABEL')
      })
      setErrorFields(prevState => [...prevState, `${field}.from`])
    } else {
      const index = errorFields.indexOf(`${field}.from`)
      if (index > -1) {
        errorFields.splice(index, 1)
      }
    }
  }

  const onLicenseBlur = (item, name) => {
    const index = errorFields.indexOf(name)
    if (index > -1) {
      errorFields.splice(index, 1)
    }
    clearErrors(name)
    const licenseNum = getValues(item)
    if (licenseNum && !/^[0-9.]*$/.test(licenseNum)) {
      setErrorFields(prevState => [...prevState, name])
      setError(name, { type: 'manual', message: i18n.t('VEHICLE_VEHICLE-LIST_WARNING-NUMERIC_LABEL') })
    }
  }

  const renderErrorText = field => {
    let errorMessage = ''
    if (errors[field]) {
      errorMessage = errors[field].message || errors[field].from.message
    }
    return errorMessage ? <p data-testid={`${field}-error-text`} className="error-text">{`${errorMessage}`}</p> : ''
  }

  const getDefaultValue = (key, fromTo) => {
    let value = ''
    if (defaultValue[key]) {
      switch (fromTo) {
        case 'from':
          if (key === 'nextRegularMaintenanceMonth') {
            value = dayjs(defaultValue[key].between[0], 'YYYY-MM-DD').format('YYYY-MM')
          } else value = defaultValue[key].between[0]
          break
        case 'to':
          if (key === 'nextRegularMaintenanceMonth') {
            value = dayjs(defaultValue[key].between[1], 'YYYY-MM-DD').format('YYYY-MM')
          } else value = defaultValue[key].between[1]
          break
      }
    }
    return value
  }

  const contains = (stringValue, charValue) => {
    return stringValue.indexOf(charValue) > -1
  }
  const allowTypeNumericOnly = (e) => {
    const invalidKey = (e.key.length === 1 && !contains(allowedChars, e.key)) || (e.key === '.' && contains(e.target.value, '.'))
    return invalidKey && e.preventDefault()
  }

  const renderInput = options => {
    let component = ''
    switch (options.type) {
      case 'select':
        component =
          <RegisterMultiSelect
            className="input-item"
            marginLeft={'10px'}
            placeholder={i18n.t('COMMON_COMMON_DROPDOWN-OPTION-ALL_LABEL')}
            options={getDropDownOptions(options.selectOptions, DropDownList)}
            valueField="key"
            labelField="value"
            element={{ value: options.name }}
          />
        break
      case 'text':
        component = (
          <input
            className="input-item"
            type={options.type}
            tabIndex={options.tabIndexes[0]}
            maxLength={options.maxLength}
            data-testid={options.name}
            {...register(options.name)} />
        )
        break
      case 'date':
      case 'month':
      case 'number':
        component = (
          <>
            <input
              {...!integerNumberOnly.includes(options.name) && { step: 'any' }}
              onKeyDown={(e) => allowTypeNumericOnly(e)}
              className="input-item"
              type={options.type === 'number' ? 'text' : options.type}
              tabIndex={options.tabIndexes[0]}
              placeholder="From"
              {...(options.type === 'date' && { min: '1890-01-01' })}
              {...(options.type !== 'month' && { max: watch(`${options.name}.to`) || '9999-12-31' })}
              {...(options.type === 'month' && { max: watch(`${options.name}.to`) || '9999-12' })}
              // max={getValues(`${options.name}.to`) || '9999-12-31'}
              defaultValue={options.type !== 'number' ? getDefaultValue(options.name, 'from') : ''}
              data-testid={`${options.name}.from`}
              {...register(`${options.name}.from`)} />
            <input
              {...!integerNumberOnly.includes(options.name) && { step: 'any' }}
              onKeyDown={(e) => allowTypeNumericOnly(e)}
              className="input-item"
              type={options.type === 'number' ? 'text' : options.type}
              tabIndex={options.tabIndexes[1]}
              placeholder="To"
              min={getValues(`${options.name}.from`) || '1890-01-01'}
              {...(options.type === 'date' && { max: '9999-12-31' })}
              {...(options.type === 'month' && { max: '9999-12' })}
              defaultValue={options.type !== 'number' ? getDefaultValue(options.name, 'to') : ''}
              data-testid={`${options.name}.to`}
              {...register(`${options.name}.to`)} />
          </>
        )
        break
    }
    return component
  }

  const renderInputGroup = options => {
    let onBlur = null
    if (options.type === 'date' || options.type === 'month') onBlur = onDateBlur(options.name)
    if (options.type === 'number') onBlur = onNumberBlur(options.name)

    return (
      <>
        <div className="label-text"><label>{i18n.t(options.label)}</label></div>
        <div>
          <div data-testid={`${options.name}-input-group`} className="input-group" onBlur={onBlur}>{renderInput(options)}</div>
          {renderErrorText(options.name)}
        </div>
      </>
    )
  }

  return (
    <FilterTabWrapper>
      <form className="form-container" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="filter-container">
          <div className="input-container">
            <div className="label-text">
              <label>{i18n.t('VEHICLE_COMMON_LICENSE-PLATE_LABEL')}</label>
            </div>
            <div>
              <div className="input-group" data-testid={'licensePlate-input-group'} onBlur={(e) => onLicenseBlur('license.number', 'license')}>
                <input
                  className="input-item"
                  type="text"
                  maxLength={255}
                  data-testid={'license.address'}
                  placeholder={i18n.t('VEHICLE_COMMON_LICENSE-PLATE-ADDRESS_LABEL')}
                  value={address || ''}
                  onChange={(e) => setValue('license.address', e.target.value)}
                  tabIndex={1} />
                <input
                  className="input-item"
                  type="text"
                  maxLength={255}
                  data-testid={'license.classNo'}
                  placeholder={i18n.t('VEHICLE_COMMON_LICENSE-PLATE-CLASS-NO_LABEL')}
                  value={classNo || ''}
                  onChange={(e) => setValue('license.classNo', e.target.value)}
                  tabIndex={2} />
                <input
                  onKeyDown={(e) => { (e.key.length === 1 && !contains('0123456789', e.key)) && e.preventDefault() }}
                  className="input-item"
                  type="text"
                  maxLength={4}
                  data-testid={'license.number'}
                  placeholder={i18n.t('VEHICLE_COMMON_LICENSE-PLATE-NUMBER_LABEL')}
                  value={number || ''}
                  onChange={(e) => setValue('license.number', e.target.value)}
                  tabIndex={3} />
              </div>
              {renderErrorText('license')}
            </div>
            {renderInputGroup(fieldNames.expensesIncludingLease)}
            {renderInputGroup(fieldNames.automobileTax)}
            {renderInputGroup(fieldNames.mileage)}
            {renderInputGroup(fieldNames.nextRegularMaintenance)}
            {renderInputGroup(fieldNames.mandatoryInsuranceEnd)}
            {renderInputGroup(fieldNames.factoryInCharge)}
          </div>
          <div className="input-container">
            {renderInputGroup(fieldNames.owner)}
            {renderInputGroup(fieldNames.leaseEndDate)}
            {renderInputGroup(fieldNames.weightTax)}
            {renderInputGroup(fieldNames.lastRegularMaintenance)}
            {renderInputGroup(fieldNames.usage)}
            {renderInputGroup(fieldNames.voluntaryInsuranceType)}
            {renderInputGroup(fieldNames.specialVehiclePassExpire)}

          </div>
          <div className="input-container">
            {renderInputGroup(fieldNames.lease)}
            {renderInputGroup(fieldNames.leaseFee)}
            {renderInputGroup(fieldNames.inspectionExpireDate)}
            {renderInputGroup(fieldNames.regularMaintenanceCycle)}
            {renderInputGroup(fieldNames.privateBusinessUse)}
            {renderInputGroup(fieldNames.voluntaryInsuranceEndDate)}

          </div>
        </div>
        <div className="submit-container">
          <SearchButton data-testid="submit-button" tabIndex={34} type="submit" {...errorFields.length > 0 && { disabled: true }}/>
        </div>
      </form>
    </FilterTabWrapper>
  )
}

export default RegistrationTab

RegistrationTab.propTypes = {
  onSearchSubmit: PropTypes.func,
  defaultValue: PropTypes.object
}
